var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisplay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2h20v14H2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.34 20v-2.24h5.464c.593 0 1.098-.213 1.516-.64.419-.427.628-.942.628-1.547L24 2.24c0-.604-.218-1.129-.654-1.573C22.911.222 22.396 0 21.804 0H2.196C1.603 0 1.09.222.654.667A2.173 2.173 0 000 2.24v13.333c0 .605.218 1.12.654 1.547.435.427.95.64 1.542.64H7.66V20h8.68zm5.464-4.425H2.196V2.242h19.608v13.334z",
    fill: "currentColor"
  })));
}
export default SvgDisplay;